export const MOVIES_URL = 'https://api.themoviedb.org/3/movie/popular?api_key=1548e9ca5849b1ab404c98f0dcaba332&language=en-US&page=1'
export const SINGLE_MOVIE_URL = (movie_id) => `https://api.themoviedb.org/3/movie/${movie_id}?api_key=1548e9ca5849b1ab404c98f0dcaba332&&language=en-US`
